import React, { useMemo } from 'react';

import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import useClassicComparatorDates from 'utils/hooks/meteorology/classicComparator/useClassicComparatorDates';
import sortedDatesAsIntervals from 'helper/Shared/sortedDatesAsIntervals';

export default function DateSelectors() {
  const {
    possibleIntervals,
    initialDate,
    setInitialDate,
    finalDate,
    setFinalDate,
  } = useClassicComparatorDates();

  const availableIntervals = useMemo(
    () => sortedDatesAsIntervals(possibleIntervals),
    [possibleIntervals],
  );

  const minDate = availableIntervals[0]?.start ?? new Date(2000, 0, 1);
  const maxDate = availableIntervals[availableIntervals.length - 1]?.end ?? new Date();

  const handleRangeChange = (dates: (Date | null)[] | Date | null) => {
    if (!Array.isArray(dates)) {
      setInitialDate(null);
      setFinalDate(null);
      return;
    }
    const [start, end] = dates;
    setInitialDate(start);
    setFinalDate(end);
  };

  return (
    <Accordion.Item eventKey="dates">
      <Accordion.Header>Período de Análise</Accordion.Header>
      <Accordion.Body>
        <DatePicker
          selectsRange
          inline
          startDate={initialDate ?? null}
          endDate={finalDate ?? null}
          onChange={handleRangeChange}
          includeDateIntervals={availableIntervals}
          minDate={minDate}
          maxDate={maxDate}
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
